import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";

import "HSNDIR/Template/ProductVideo.js";
import "HSNDIR/Carousel.js";
import "HSNDIR/Widget/AltImageCarousel.js";

let Video = HSN.Widget.Video;
let modernizr = Modernizr;

HSN.Widget.ProductCards = (function () {
    /// <summary>Encapsulates the functionality of a Product Card.</summary>
    /// <param name="config" type="object">
    /// A set of key/value pairs that configure the ProductCards.
    /// - application (HSN.Application): The [[HSN.Application]] instance this template exists within and should interact with.
    /// - container (HTMLElement): The HTML element that acts as the root container for the template.
    /// </param>

    /* Instances shared properties go here, dont use this keyword here */

    var previewElement = null;
    var getPreviewElement = function () {
        ///<summary>Lazy-instantiates and provides access to the jQuery-wrapped HTMLElement that acts as the preview button for each of the product cards in the grid.</summary>
        ///<returns type="jQuery">preview element</returns>
        if (null === previewElement) {
            if ($('.bloomreach').length) {
                previewElement = $('<div class="quick-view">Quick View</div>');
            }
            else {
                previewElement = $('<div class="preview">Preview</div>');
            }
        }
        return previewElement;
    };

    // Returns card position taking into account ingridcards but ignoring hook logic
    function getCardPosition(webId) {
        var index = 0;
        var skipStr = HSN.Instance().GetQueryStringParam(window.location.href, "skip");
        var skip = (skipStr) ? parseInt(skipStr) : 0;
        var found = false;

        // Prevent div with class .item underneath left item from counting
        var parent = $("#template-product-grid .grid-right");
        if (!parent.length)
            parent = $("#template-product-grid");

        parent.find(".item").each(function () {
            var cur = $(this);
            var curId = cur.data("productId");

            index += 1;

            if (curId && curId == webId) {
                found = true;
                return false;
            }
        });

        if (found) {
            return skip + index;
        }
        else {
            return 0;
        }
    }

    var bindEvents = function () {
        var scope = this;
        $('body')
            .on('click', '.lessman-pdcard-video', function () {
                // ReSharper disable once UnusedLocals
                var productVideo = new HSN.Template.ProductVideo({
                    application: HSN.Instance(),
                    videoUrls: { httpUrl: $(this).data('httpUrl') },
                    videoAnalytics: { name: $(this).data('analyticName'), category: $(this).data('analyticCat') },
                    assetId: $(this).data('assetid'),
                    webpid: $(this).data('productId'),
                    backgroundColor: '#000000'
                });

                return false;
            })
            .on('click', '.brand-item, .product-item, .list-product-item, .tall-product-item', function () {
                // Make the entire product card clickable to the product detail page unless a lower element overrides.
                if (this.className !== 'item product-item module violated in-grid' && $('#all-brands-form').length === 0) {
                    var cur = $(this);

                    var url = cur.find('h3>a').attr('href');
                    if (url == undefined) {
                        url = cur.data('product-url');
                    }

                    var id = cur.data('productId');
                    var matrixId = cur.data('matrixId');
                    var curId = (!matrixId || matrixId == 0 ? id : matrixId);

                    if (cur.parents('.is-host-closet').length) {
                        HSN.DataLayer.helpers.metricEvent(null, 'RE:programguide', 'hosts-closet', curId);
                    }
                    else {
                        HSN.DataLayer.helpers.hsnEvent({
                            'product_variant_id': curId,
                            'product_position': getCardPosition(id),
                            'product_click_id': curId,
                            'matrix_id': (!matrixId || matrixId == 0 ? 'undefined' : matrixId)
                        }, 'ProductClick', 'Success');

                        HSN.DataLayer.helpers.metricEvent(null, 'RE:grid', 'productclick', 'NA');
                    }

                    window.location = url;
                }
            })
            .on('click', '.item .preview', function (e) {
                e.stopPropagation();

                var data = $(this).closest('.item').data();
                var id = data['productId'];
                var matrixId = data['matrixId'];

                scope.application.GetProductPreviewOffCanvas().Show(id);

                HSN.DataLayer.helpers.hsnEvent({
                    'product_variant_id': (!matrixId || matrixId == 0 ? id : matrixId),
                    'product_position': getCardPosition(id),
                }, 'ProductClick', 'Success');
                return false;
            }).on('click', '.item .quick-view', function (e) {
                e.stopPropagation();
                $('.quickview-container').hide();
                var position = $(this).closest('.item').position();
                var data = $(this).closest('.item').data();
                var id = data['productId'];
                var container = $('.quickview-container.' + id);
                container.css('top', position.top - 160).css('left', position.left - 150);
                $(container).show();

            }).on('mouseleave', '.item, .quickview-container', function (e) {
                $('.quickview-container').hide();
            })
            .on('click', '.tall-product-item .video a, .product-item .video a', function (e) {
                e.stopPropagation();
                e.preventDefault();

                var imageContainer = $(this).parent('.video').siblings('.info').find('.image');
                imageContainer.data('video-playing', true);
                var carousel = $('ul', imageContainer).data("carousel");
                if (carousel) {
                    carousel.toggleAutoScroll(false);
                }

                var button = $(this);
                var parent;
                var videoPlayer;
                //seperate tall grid from normal grid:
                if ($(this).parents('.tall-product-item').length > 0) {
                    parent = $(this).parents('.tall-product-item');
                    videoPlayer = parent.find('.grid-video-player-tall');
                } else {
                    parent = $(this).parents('.product-item');
                    videoPlayer = parent.find('.grid-video-player');
                }

                var image = parent.find('.image').find('img');

                var videoData = {};
                videoData.w = button.data('w');
                videoData.h = button.data('h');
                videoData.httpUrl = button.attr('href');
                videoData.iosUrl = button.attr('href');

                videoData.analyticCat = button.data('analyticCat');
                videoData.analyticName = button.data('analyticName');
                videoData.application = scope.application;


                //playover overrides:
                videoData.overrides = {
                    rules:
                    {
                        android:
                        {
                            regexp: 'Android'
                        }
                    },

                    media: {
                        title: videoData.analyticName,
                        source: [
                            { src: videoData.httpUrl, type: 'video/mp4' }
                        ]
                    },
                    autoplay: true,
                    controls: {
                        mode: 'none'
                    },
                    captioning:
                    {
                        enabled: true
                    }
                };

                //create the player and listen to ready and ended events:
                var video = new Video(videoData, videoPlayer.attr('id'), function () {
                    var player = video.getPlayer();
                    // ReSharper disable once Html.EventNotResolved
                    player.addEventListener('ready', function () {
                        video.controls('none');
                    });

                    // ReSharper disable once Html.EventNotResolved
                    player.addEventListener('ended', function () {
                        videoPlayer.hide();
                        video.stop();
                        image.show();
                        button.show();
                    });

                    //show video, hide other elements:
                    videoPlayer.show();
                    image.hide();
                    button.hide();
                });

                return false;
            })
            .on('click', '.product-item .swatches a, .list-product-item .swatches a', function (e) {
                e.preventDefault();

                var a = $(this);
                var alternates = a.data('alternates');
                $('.image', a.closest('.item')).html($('<img>', { src: alternates[0] }));

                return false;
            })
            .on('keydown', 'li.product-container.slick-slide', function (e) {
                if (e.key === 'Enter') {
                    var li = $(this);

                    e.preventDefault();
                    e.stopPropagation();

                    var link = li.find('a');
                    if (link.length > 0) {
                        window.location.href = link.attr('href');
                    }
                }
            });
            
            var listItems = [];
            $('body').on('keyup focus', 'li.product-container.slick-slide', function (e) {
                if (listItems.length === 0) {
                    listItems = $('li.product-container.slick-slide');

                    listItems.each(function () {
                        $(this).children().on('keyup focus', function (e) { onLIFocusAndKeyup(e); })
                    });                    
                }

                onLIFocusAndKeyup(e);
            });                       

        var onLIFocusAndKeyup = function (e) {
            if (e.type === 'focus' || e.key === 'Tab') {
                var target = $(e.target);
                if (!(target.is('li.product-container.slick-slide'))) {
                    target = target.parents('li.product-container.slick-slide');
                }

                target.find('a').attr({
                    'tabindex': '-1'
                });
                target.find('input').attr({
                    'tabindex': '-1'
                });
            }
        };

        var preventMouseover = false;

        this.$container
            .on('touchstart', function (e) {
                preventMouseover = true;
            })
            .on('mouseenter', '.product-item .image, .list-product-item .image', function () {
                if (preventMouseover) return;

                var img = $(this).find('img');
                var alternates = img.data('alternates');
                var index = 0;
                var swapper = function () {
                    // Loop back around to the beginning.
                    if (alternates === undefined) {
                        return;
                    }
                    if (index > (alternates.length - 1)) {
                        index = 0;
                    }

                    var currentImg = alternates[index];
                    if (currentImg !== alternates[index++]) {
                        img.attr('src', alternates[index++]);
                        scope.alternatesTimeout = setTimeout(swapper, 1000);
                    }
                };
                swapper();
            })
            .on('mouseleave', '.product-item .image, .list-product-item .image', function () {
                if (preventMouseover) return;

                if (null !== scope.alternatesTimeout) {
                    clearTimeout(scope.alternatesTimeout);
                    scope.alternatesTimeout = null;
                }
                var img = $(this).find('img');
                var alternates = img.data('alternates');
                if (alternates === undefined) {
                    return;
                }
                img.attr('src', alternates[0]);
            })
            .on('mouseenter', '.product-item .info:not(.product-ensemble), .list-product-item .info:not(.product-ensemble)', function () {
                if (preventMouseover) return;

                // Move our preview button into this product card.
                $(this).append(getPreviewElement());
            })
            .on('mouseleave', '.product-item .info:not(.product-ensemble), .list-product-item .info:not(.product-ensemble)', function () {
                if (preventMouseover) return;

                // Remove our preview button from this product card, but keep it around for future use.
                getPreviewElement().detach();
            })
            .on('mouseenter', '.product-item .info .video', function () {
                if (preventMouseover) return;

                getPreviewElement().detach();
            })
            .on('mouseleave', '.product-item .info .video', function () {
                if (preventMouseover) return;

                $(this).closest('.info').append(getPreviewElement());
            })
            .on('mouseenter', '.product-item .image, .list-product-item .image, .tall-product-item .image', function (e) {
                if (preventMouseover) return;

                var cur = $(e.currentTarget);
                var carousel = $('ul', cur);
                var imgs = $('img', cur);                

                if (cur.data('video-playing')) {
                        return;
                    }

                if (imgs.first().attr('src') === imgs.next().attr('src')) {
                        altSameImages = true;
                    }

                cur.addClass('new-alt hovered');   

                if (!carousel.data('hsn-carousel') && imgs.length > 1) {
                            new HSN.Widget.AltImageCarousel({
                                application: scope.application,
                                container: cur,
                                preloadFirstImage: true
                            });
                }                  
                
            });

        /* Playing Product Videos */
        this.application.Events.On(HSN.Application.EVENT.VIDEO_COMPLETE,
            function (videoGridObj) {
                var currentObj = videoGridObj.parents();

                currentObj.find('.video-player')
                    .hide()
                    .children()
                    .remove();
                currentObj.find('.play')
                    .show();
                currentObj.find('.tall-product-item .image img, .product-item .image img')
                    .show();
            });
    };

    var constructor = function (config) {
        var scope = this;
        /* Instance specific properties go here */
        this.application = config.application;
        this.$container = $(config.container);
        this.alternatesTimeout = null;

        bindEvents.call(this);

        // This abomination supports keyboard revealing/initializing the alt carousel when inside a card
        
         var cards = scope.$container.find('.product-item, .list-product-item, .tall-product-item')
         cards.each((i, el) => {
                    var curCard = $(el);
                    var image = curCard.find('.image');
                    if (image.length) {
                        curCard.one('focusin', () => {
                            image.addClass('new-alt hovered');
                            var carousel = image.find('ul');
                            var imgs = carousel.find('img');
                            if (!carousel.data('hsn-carousel') && imgs.length > 1) {
                                new HSN.Widget.AltImageCarousel({
                                    application: scope.application,
                                    container: image,
                                    preloadFirstImage: true
                                });
                            }
                        })
                        .on('focusout', () => {
                            setTimeout(() => {
                                if (!curCard.has(':focus').length) {
                                    image.removeClass('hovered');
                                }
                            }, 100);
                        })
                        .on('focusin', () => {
                            image.addClass('hovered');
                        })
                        .on('mouseenter', () => {
                            image.addClass('hovered');
                        })
                        .on('mouseleave', () => {
                            image.removeClass('hovered');
                        });
                    }
                });
            
    };

    constructor.prototype = {
        constructor: constructor,
        refresh: function () {
            if (!Modernizr.touchevents) {
                HSN.Tooltip(this.$container.find('[data-tooltip]'));
            }
        }
    };

    return constructor;
})();



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/ProductCards.js